<template>
    <div>
<div class="md-layout-item md-size-100 header text-center">
            <h3 class="title" id="destwebsites">Websites</h3>

            <div class="md-layout">  
                <div class="md-layout-item md-size-15">
                    <md-field>
                        <label for="portfolio">Portfolio</label>
                        <md-select v-model="portfolioId" name="portfolio" id="portfolio">
                             <md-option>All</md-option>
                             <md-option v-for="port in sitePortfolios" :key="port.id" :value="port.id">{{port.name}}</md-option>
                        </md-select>
                    </md-field>
                </div>
                <div class="md-layout-item">
                    <ul class="list_alphabet">
                        <li v-for="letter in alphabet" :key="letter" :class="{ selected: selectedLetter === letter }"><a @click="selectLetter(letter)">{{letter}}</a></li>
                    </ul>
                </div>
                <div class="md-layout-item md-size-15">
                    <md-field>
                        <label for="search">Search</label>
                        <md-input v-model="searchText" id="search" name="search" autocomplete="new-search" placeholder="Search..." />
                    </md-field>
                </div>
            </div>
        </div>

        <transition-group type="transition" name="list-complete" tag="div" class="md-layout">
            <website-card v-for="web in computedSitesList" :website="web" :key="web.id" 
                          class="list-complete-item md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25"></website-card>
        </transition-group>

            <div v-if="computedSitesList.length === 0" class="sites_list_empty md-layout-item md-size-100 text-center">
                <h2>No Sites to Display</h2>
                <a v-if="displaySitesResetFiltersOption" @click="resetSitesFilters" class="a_default">Reset Filters</a>
            </div>
        </div>
</template>
<script>

    import Help from "@/ts/Help";

       import {
        WebsiteCard
    } from "@/components";


    export default {
        components: {
            WebsiteCard
        },
        props: {
            sitePortfolios: {
                type: Array,
                default: () => []
            },
            sites: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                portfolioId: false,
                alphabet: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                selectedLetter: null,
                searchText: '',
                //sitePortfolios: [],
            }
        },
        methods:{
           resetSitesFilters() {
                this.portfolioId = false;
                this.selectedLetter = null;
                this.searchText = '';
            },

            selectLetter(theLetter) {
                if (this.selectedLetter === theLetter) {
                    this.selectedLetter = null;
                }
                else {
                    this.selectedLetter = theLetter;
                }
            },
        },
        computed: {
             displaySitesResetFiltersOption() {
                return this.sites.length > 0;
            },

            computedSitesList: function () {
                var self = this;
                return this.sites.filter(function (web) {
                    var matchingFirstLetter = Help.isGoodString(self.selectedLetter)? web.firstLetter === self.selectedLetter : true;
                    var matchingPortfolioId = Help.isGoodNumber(self.portfolioId) ? web.portfolioId === self.portfolioId : true;
                    var matchingSearchTerm = Help.isGoodString(self.searchText)? web.name.toLowerCase().indexOf(self.searchText.toLowerCase()) !== -1 : true;
                    return matchingFirstLetter && matchingPortfolioId && matchingSearchTerm;
                });
            }
        }
    };
</script>











<!--//alphabet: {
            //    type: Array,
            //    default: () => []
            //},
            // sitesList: {
            //    type: Array,
            //    default: () => []
            //},
            //  portfolios: {
            //    type: Array,
            //    default: () => []
            //},  
            //portfolioId:null,
            //selectedLetter: {
            //    type: String,
            //    default: null
            //},//sitesSelectedLetter:'',
            //searchText: {
            //    type: String,
            //    default: ''
            //},
            //displaySitesResetFiltersOption: {
            //    type: Boolean,
            //    default: false,
            //},-->